"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackArrow = function BackArrow(_ref) {
  var className = _ref.className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 13 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 22 : _ref$height;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: width,
    height: height,
    viewBox: "0 0 ".concat(width, " ").concat(height),
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 1L2 11L12 21",
    stroke: "#505050",
    strokeWidth: "2"
  }));
};

BackArrow.propTypes = {
  className: _propTypes.string
};
var _default = BackArrow;
exports.default = _default;